// extracted by mini-css-extract-plugin
export var active = "_f3-7";
export var blink = "_f3-8";
export var dropDownSelector = "_f3-4";
export var dropDownWrapper = "_f3-3";
export var fakeCursor = "_f3-6";
export var fontSizeButton = "_f3-9";
export var formQuillEditor = "_f3-0";
export var pressed = "_f3-a";
export var qlBlank = "_f3-1";
export var textFormattingToolbar = "_f3-2";
export var textToolbarOption = "_f3-5";